import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _Number$parseInt from "@babel/runtime-corejs3/core-js-stable/number/parse-int";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'UASystemConfiguration' store object.
 * @namespace SystemConfigurationSelectors
 */
var selectors = /*#__PURE__*/_createClass(function selectors() {
  _classCallCheck(this, selectors);
});
/**
 * @private
 */
_defineProperty(selectors, "moduleIdentifier", 'UASystemConfiguration');
/**
 * Returns all system configurations from 'UASystemConfiguration' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof SystemConfigurationSelectors
 */
_defineProperty(selectors, "getSystemConfiguration", function (state) {
  return state[selectors.moduleIdentifier].systemConfiguration.payload;
});
/**
 * Returns the value of a specific system configuration
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof SystemConfigurationSelectors
 */
_defineProperty(selectors, "getValue", function (state, key) {
  var systemProperties = state[selectors.moduleIdentifier].systemConfiguration.payload;
  if (Array.isArray(systemProperties)) {
    var _iterator = _createForOfIteratorHelper(systemProperties),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var systemProperty = _step.value;
        if (systemProperty.propertyName === key) {
          return systemProperty.propertyValue;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return null;
});
/**
 * Returns the integer value of a specific system configuration property
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof SystemConfigurationSelectors
 */
_defineProperty(selectors, "getIntegerValue", function (state, key) {
  return _Number$parseInt(selectors.getValue(state, key), 10);
});
/**
 * Returns the value of a specific system configuration converted to boolean equivalent
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof SystemConfigurationSelectors
 */
_defineProperty(selectors, "getBooleanValue", function (state, key) {
  var value = selectors.getValue(state, key);
  if (value && (value === true || value === 'true' || value.toLowerCase() === 'yes')) {
    return true;
  }
  if (value && (value === 'false' || value.toLowerCase() === 'no')) {
    return false;
  }
  return null;
});
/**
 * Selects the indicator that specifies whether system configurations are being
 * retrieved or not, from the 'UASystemConfiguration' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof SystemConfigurationSelectors
 */
_defineProperty(selectors, "isFetchingSystemConfiguration", function (state) {
  return state[selectors.moduleIdentifier].isFetchingSystemConfiguration.payload;
});
/**
 * Selects the system configurations error from the 'UASystemConfiguration' store object.
 *
 * @param {Object} state
 * @function
 * @static
 * @memberof SystemConfigurationSelectors
 */
_defineProperty(selectors, "systemConfigurationError", function (state) {
  return state[selectors.moduleIdentifier].systemConfigurationError.payload;
});
export { selectors as default };